import { FC, useEffect, useState, memo } from "react"
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface TextInputProps {
    id?: string;
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    required?: boolean;
    autoComplete?: string;
    defaultValue?: string;
    ignore?: boolean;
    disabled?: boolean;
    maxLength?: number;
    showCharacterCount?: boolean;
    helperText?: string;
    icon?: React.ReactNode;
}

const TextInput: FC<TextInputProps> = ({ id, label, value, onChange, placeholder = '', required = false, autoComplete = ``, defaultValue, ignore = false, disabled = false, maxLength, showCharacterCount = true, helperText, icon }) => {

    const [initilized, setInitilized] = useState(false)
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    useEffect(() => {
        if (!initilized) {
            setInitilized(true)
            if (defaultValue) {
                onChange({target: {value: defaultValue}} as React.ChangeEvent<HTMLInputElement>)
            }
        }
    }, [initilized, defaultValue, onChange])
    
    return (
        <div className="input-holder relative w-full sm:max-w-none md:max-w-64">
            <label>{label}{required ? '*' : ''}</label>
            <input
                id={id}
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={(e) => {
                    onValidityChange(e)
                    onChange(e)
                }}
                onBlur={onBlur}
                onInvalid={onInvalid}
                autoComplete={autoComplete}
                required={required}
                data-ignore={ignore ? `true` : `false`}
                disabled={disabled || disableInputs}
                className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''}`}
                maxLength={maxLength}
            />
            {icon && (
                <div className="absolute left-2 bottom-[0.5rem] [&>svg]:fill-gray-500 [&>svg]:h-6 [&>svg]:w-6">
                    {icon}
                </div>
            )}
            <FieldError message={errorMessage} />
            {showCharacterCount && maxLength && (
                <div className="text-xs text-gray-500 mt-1">
                    {value.length}/{maxLength} characters
                </div>
            )}
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(TextInput)

